let resumeData = {
  "imagebaseurl": "https://akshat103.github.io/Portfolio/",
  "name": "Akshat Tamrakar",
  "role": "Web developer and Data Enthusiast",
  "roleDescription": " Are you ready to take your business to the next level? Look no further! Unlock your business potential with a skilled web developer. I offer captivating designs, seamless functionality, and tailored solutions that elevate your online presence.",
  "mail":"akshattamrakar.work@gmail.com",
  resume_url:"https://drive.usercontent.google.com/u/0/uc?id=1W5dBcLxZGsB5aUcPZ2sEmrcPCi00HGsP&export=download",
  "socialLinks": [
    {
      "name": "linkedin",
      "url": "https://www.linkedin.com/in/akshat-tamrakar08",
      "className": "fa fa-linkedin"
    },
    {
      "name": "github",
      "url": "https://github.com/Akshat103",
      "className": "fa fa-github"
    },
    {
      "name": "twitter",
      "url": "https://twitter.com/anotherakshat",
      "className": "fa fa-twitter"
    }
  ],
  "aboutme": "I am currently a pre-final year student at Medicaps University and pursuing my B.Tech from here. I am a self taught Full Stack Web Developer also diving deeper into Machine Learning. I am a motivated, teamwork-oriented, and responsible Data Analyst with significant experience in increasing comprehension of reports and presentations.",
  "address": "Indore, Madhya Pradesh, India",
  "website": "https://akshattamrakar.vercel.com",
  "education": [
    {
      "UniversityName": "Medicaps University",
      "specialization": "Information Technology",
      "YearOfPassing": "2025",
      "Achievements": "8.7 (latest)"
    },
    {
      "UniversityName": "Christ Church Convent",
      "specialization": "High Schooling",
      "YearOfPassing": "2021",
      "Achievements": "93.4%"
    }
  ],
  "work": [
    {
      "CompanyName": "Stolid",
      "specialization": "Internship",
      "MonthOfLeaving": "June-July",
      "YearOfLeaving": "2023",
    },
    {
      "CompanyName": "ACM Medicaps University",
      "specialization": "Technical Team Lead",
      "MonthOfLeaving": "Jan-Sept",
      "YearOfLeaving": "2023",
    }
  ],
  "skillsDescription": "Your skills here",
  skills: [
    {
      category: "Languages",
      skillsList: ["C++", "Javascript", "Java", "Python", "SQL"],
    },
    {
      category: "Libraries/Frameworks",
      skillsList: [
        "React",
        "NodeJS",
        "Express",
        "Hadoop",
        "Pandas",
        "Numpy",
        "Matplotlib",
      ],
    },
    {
      category: "Databases",
      skillsList: ["MongoDB", "MySQL", "Redis"],
    },
    {
      category: "Platforms/Tools",
      skillsList: [
        "Netlify",
        "GitHub Pages",
        "Vercel",
        "Git",
        "Databricks",
        "Sqoop",
        "Hive",
        "Azure Container",
        "AWS S3",
        "AWS EC2",
      ],
    },
  ],  
  "portfolio": [
    {
      "name": "TenderBig",
      "description": "List tenders and apply for various tenders.",
      "imgurl": "images/portfolio/tenderbig.png",
      "projectLink": "https://tenderbig.com"
    },
    {
      "name": "Inventory Management",
      "description": "Inventory management system to manage inventory by multiple users in a secure and efficient manner.",
      "imgurl": "images/portfolio/invm.png",
      "githubLink": "https://github.com/Akshat103/Inventory-Management",
      "projectLink": "https://inventory-management-pi.vercel.app"
    },
    {
      "name": "Technical Tambola",
      "description": "A web-based platform for playing Tambola where players can log in and receive their unique tickets to play Tambola.",
      "imgurl": "images/portfolio/techtam.png",
      "githubLink": "https://github.com/Akshat103/Technical_Tambola",
      "projectLink": "https://technical-tambola.medicaps.hosting.acm.org/"
    },
    {
      "name": "Dumply",
      "description": "Platform to classify e-waste into different classes.",
      "imgurl": "images/portfolio/dp.PNG",
      "githubLink": "https://github.com/Akshat103/Dumply",
    },
    {
      "name": "Data Entry",
      "description": "Web app to for data entry, delete, serach and display.",
      "imgurl": "images/portfolio/de.PNG",
      "githubLink": "https://github.com/Akshat103/Details-Entry",
      "projectLink": "https://akshat103.github.io/Details-Entry"
    },
    {
      "name": "Handsel",
      "description": "On new year everyone is curious about their future and has so much hopes for it. Also it inspired by fortune cookies concept of giving a hint of future.",
      "imgurl": "images/portfolio/handsel.jpg",
      "githubLink": "https://github.com/Akshat103/Handsel",
    },
    {
      "name": "Notes",
      "description": "A note making app using Js. It store the notes in local storage.",
      "imgurl": "images/portfolio/notes.PNG",
      "githubLink": "https://github.com/Akshat103/Notes-app",
      "projectLink": "https://akshat103.github.io/Notes-app/"
    },
    {
      "name": "Diseases Prediction",
      "description": "Web application made using three prediction models.",
      "imgurl": "images/portfolio/dpml.PNG",
      "githubLink": "https://github.com/Akshat103/Diseases_Prediction_App",
      "projectLink": "https://diseases-prediction-system.streamlit.app/"
    },
  ]
}

export default resumeData